import angular from 'angular';
import _ from 'lodash-es';
import kformUtils from '../../utils/kform-utils';
import template from '../textfield/textfield.html';

const emailConfig = /* @ngInject */ (/** @type {any} */ KformComponentsProvider) => {
	const views = _.cloneDeep(KformComponentsProvider.$get().components.textfield.views);
	// _.each(views, view => {
	// 	if (view.name === 'Validation') {
	// 		view.template = 'kform/components/email/validate.html';
	// 	}
	// });

	KformComponentsProvider.register('email', {
		title: 'Email',
		template,
		group: 'advanced',
		children:   false,
		selectable: true,
		settings: {
			autofocus:    false,
			input:        true,
			tableView:    true,
			inputType:    'email',
			label:        'Email',
			key:          'email',
			hideLabel:    false,
			placeholder:  '',
			prefix:       '',
			suffix:       '',
			defaultValue: '',
			protected:    false,
			persistent:   true,
			hidden:       false,
			clearOnHide:  true,
			kickbox:      {
				enabled: false,
			},
			event:        {
				onChange: null,
			},
			kdata:        {
				submit: true,
			},
			validate:     {
				card:          '0-1',
				minLength:     null,
				maxLength:     null,
				pattern:       '',
				custom:        '',
			},
		},
		icon: 'fa fa-at',
		views,
		controller: /* @ngInject */ (/** @type {any} */ $scope) => {
			$scope.maskOptions = {
				// inputMask: /^[\w-.]+@([\w-]+\.)+[\w-]{2,4}$/,
				inputMask: String,
			};

			if ($scope.options?.building) {
				return;
			}

			$scope.changeValue = () => {
				if (typeof $scope.component.event.onChange === 'string') {
					const custom = ''.concat($scope.component.event.onChange, '; ');
					kformUtils.evaluate(custom, {
						data: $scope.data,
						form: $scope.form,
					});
				}
			};
		},
	});
};

export default angular.module('app').config(emailConfig);
